import React from 'react'
import InsightCard from './InsightCard'

const TanPriceCard = ({totalBuyGold, totalSellGold}) => {
  const convertToBuyNum = Number(totalBuyGold);
  const convertToSellNum = Number(totalSellGold);
  const roundBuy = Math.round(convertToBuyNum);
  const roundSell = Math.round(convertToSellNum);
  return (
    <div className='bg-white w-full rounded-md px-6 py-11'>
        <div className='pb-5'>

        <InsightCard heading="Total Buy" price={`${roundBuy} G`} bgColor="bg-secondary-yellow-600" />
        </div>
        <InsightCard heading="Total Sell" price={`${roundSell} G`} bgColor="bg-primary-red-500" />

    </div>
  )
}

export default TanPriceCard